// @flow
import App from './App';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { compose, withHandlers, mapProps, setDisplayName } from 'recompose';
import * as signals from '../../application/signals';
import * as selectors from '../../domain/selectors';
import { FQDN_MAX_LENGTH } from '../../domain/filter';
import * as r from 'ramda';

const mapStateToProps = (state) => {
  return {
    seeded: selectors.isSeeded(state),
    localeLoaded: selectors.isLocaleLoaded(state),
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({
    seed: signals.seed,
  }, dispatch);
};

const mergeProps = (stateProps, dispatchProps, ownProps) => {
  return {
    ...stateProps,
    ...ownProps,
    actions: {
      ...dispatchProps,
      ...ownProps.actions,
    },
  };
};

export const enhance = compose(
  setDisplayName('ConnectedApp'),
  mapProps((ownProps) => ({
    theme: ownProps.theme,
    legal: ownProps.legal,
    tlds: r.take(3, r.defaultTo([], ownProps.tlds)),
    currency: ownProps.currency,
    locale: ownProps.locale,
    messages: ownProps.messages,
    features: r.merge({
      premium: true,
      backorder: true,
      transfer: true,
      canUnspin: false,
      filters: true,
      negotiate: false,
      bundles: false,
    }, ownProps.features),
    transferableTlds: ownProps.transferableTlds,
    backorderableTlds: ownProps.backorderableTlds,
    negotiableTlds: ownProps.negotiableTlds,
    basketFqdns: r.when(
      r.is(Array),
      r.concat([]),
    )(ownProps.basket),
    stickyOffset: ownProps.stickyOffset,
    unspunTlds: r.defaultTo([], ownProps.unspunTlds),
    initialFilters: r.pipe(
      r.defaultTo({}),
      r.merge(r.__, {
        length: FQDN_MAX_LENGTH,
      }),
    )(ownProps.filters),
    includeTax: ownProps.includeTax,
    usePPE: ownProps.usePPE,
    requiresContainer: ownProps.requiresContainer,
    displayPricing: ownProps.displayPricing,
    negotiate: r.pipe(
      r.defaultTo({}),
      r.merge({
        price: null,
        showLegalTerms: false,
      }),
    )(ownProps.negotiate),
    config: ownProps,
  })),
  connect(mapStateToProps, mapDispatchToProps, mergeProps),
  withHandlers({
    onSeed: ({
      actions,
      config,
      features,
      locale,
      usePPE,
      includeTax,
      initialFilters,
    }) => (
      query,
      brandId,
    ) => actions.seed(
      query,
      brandId,
      locale,
      config.exchangeRate,
      config.minTldLength,
      config.bundle,
      features,
      config.asyncHooks,
      usePPE,
      includeTax,
      config.unspunTlds,
      initialFilters,
    ),
  }),
);

export default enhance(App);
